module.exports = __webpack_public_path__ + "static/media/5.question.808232b3.mp4";